module.exports = __webpack_public_path__ + "static/media/noauth_image.952e8cba.png";